import { get, patch, post, remove } from '@va/http-client';
import { storageItems } from '@va/standalone/shared/constants';
import { LocalStorage } from '@va/util/helpers';

export const getAgencyThemes = (userIdValue: string) => {
  const url = `/users/${userIdValue}/agencyui/theme/all`;
  return get(url, {});
};

export const getAgencyUi = () => {
  const userId = LocalStorage.getItem(storageItems['userId']);
  const url = `/users/${userId}/agencyui`;
  return get(url, {});
};

export const getWebsiteAgencyUi = (websiteId: string) => {
  const url = `/websites/${websiteId}/agencyui`;
  return get(url, {});
};

export const getCustomUrlAgencyUi = (customUrl: string) => {
  const url = `/agencyui?url=${customUrl}`;
  return get(url, {});
};

export const changeWebsiteWhiteLabelStatus = (websiteId: string, data: Record<string, unknown>) => {
  const url = `/websites/${websiteId}/white-label/status/change`;
  return patch(url, {}, data);
};

type YearlyCommissionResponse = { yearlyCommission: Record<string, number> };
export const getAgencyYearlyCommission: () => Promise<YearlyCommissionResponse> = () => {
  const userId = LocalStorage.getItem(storageItems['userId']);
  const url = `/users/${userId}/agencyui/commission-yearly`;
  return get(url, {}) as Promise<YearlyCommissionResponse>;
};
export const getAgencyQuaterlyCommission = () => {
  const userId = LocalStorage.getItem(storageItems['userId']);
  const url = `/users/${userId}/agencyui/commission-quarterly`;
  return get(url, {});
};
